import {useState} from 'react';
import {createPlant} from "../../services/Administrative/plantService";

export const useCreatePlant = () => {
    const [savingNewPlant, setSavingNewPlant] = useState(false);

    const createNewPlant = async (newPlantDTO: any) => {
        setSavingNewPlant(true);
        try {
            const response =  await createPlant(newPlantDTO);
        } catch (error: any) {
            throw error;
        } finally {
            setTimeout(() => setSavingNewPlant(false), 600);
        }
    };

    return {createNewPlant, savingNewPlant};
};
